import { useState } from "react";
import { GOD_COMMENTS } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

export default function ShenPing() {
  const [likedIds, setLikedIds] = useState<string[]>([]);

  const toggleLike = (id: string) => {
    setLikedIds((ids) => (ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]));
  };

  return (
    <section id="shenping" className="bg-secondary-100/40 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16">
        <SectionHeading
          kicker="神评墙"
          title="网友的嘴，从不让人失望"
          desc="精选瓜友对热门事件的花式点评，每一句都是吃瓜的灵魂，欢迎来前排对对暗号。"
          align="center"
        />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {GOD_COMMENTS.map((c) => {
            const liked = likedIds.includes(c.id);
            return (
              <figure
                key={c.id}
                className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between">
                  <span
                    className="grid h-9 w-9 place-items-center rounded-full text-sm font-bold text-background-50"
                    style={{ backgroundColor: `oklch(0.6 0.18 ${c.hue})` }}
                  >
                    {c.author.slice(0, 1)}
                  </span>
                  <i className="ri-double-quotes-l text-2xl text-secondary-300"></i>
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-6 text-foreground-800">
                  “{c.content}”
                </blockquote>
                <figcaption className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <div className="min-w-0">
                    <div className="truncate text-xs font-medium text-foreground-900">{c.author}</div>
                    <div className="truncate text-[11px] text-foreground-500">围观 · {c.context}</div>
                  </div>
                  <button
                    onClick={() => toggleLike(c.id)}
                    aria-label="给神评点赞"
                    className={`inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-xs transition-colors hover:bg-secondary-200 ${
                      liked ? "text-secondary-700" : "text-foreground-500"
                    }`}
                  >
                    <i className={liked ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                    {liked ? c.likes + 1 : c.likes}
                  </button>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}